import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import LoadingBar from '../share/LoadingBar';

class ProductImages extends Component {
  constructor(props) {
    super(props);
    const {
      products, actions, loading, apiToken,
    } = this.props;

    if (loading === false && !products) {
      actions.getAllResources(apiToken, 'products');
    }
  }

  render() {
    const {
      products, actions, loading, apiToken, match,
    } = this.props;
    const { resourceId } = match.params;
    let imagesData = (products) ? (products.filter(prod => prod.id == resourceId)[0].images) : [];
    imagesData = imagesData || [];
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <DisplayResources
            data={imagesData}
            actions={actions}
            fieldNames={resourceFields.images}
            resourceName="images"
            buttonArray={[]}
            apiToken={apiToken}
          />
        )
    );
  }
}

ProductImages.propTypes = {
  loading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

ProductImages.defaultProps = {
  products: null,
};

export default withRouter(ProductImages);
